import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AccountLookupResponse, ProfileItem } from 'qp-ui-interface';
import { manageResponse } from 'qp-utility';
import { DatazoomService } from '../../../analytics/datazoom/service/datazoom.service';
import { SearchService } from '../../../search-page/search.service';
import { StorefrontService } from '../../../storefront/storefront.service';
import { LocalStorageKeys } from '../../LocalStorageKeys';
import { cleanRoutes } from '../../utils/LoginUtils';
import { ConfigService } from '../config/config.service';
import { PlaybackService } from '../playback/playback.service';
import { QPATService } from '../qpat/qpat.service';
import { TabService } from '../tabs/tab.service';
import { UserStateService } from '../user-state/user-state.service';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private qpatService: QPATService,
    private userState: UserStateService,
    private router: Router,
    private tabService: TabService,
    private datazoomService: DatazoomService,
    private searchService: SearchService,
    private localStorage: LocalStorageService,
    private storefrontService: StorefrontService // private authservice: AuthService
  ) {}

  async getProfiles(): Promise<AccountLookupResponse> {
    return this.http
      .post<any>(`${this.configService.applicationConfig.umsURL}/user/account/lookup`, {})
      .toPromise()
      .then((profilesResponse) => {
        const response = manageResponse<AccountLookupResponse>(profilesResponse);
        this.localStorage.setItem(LocalStorageKeys.PROFILES, JSON.stringify(response.profiles));
        this.localStorage.setItem(LocalStorageKeys.ACCOUNT_EMAIL, response.email);
        this.localStorage.setItem(LocalStorageKeys.ACCOUNT_ID, response.id);
        return { ...response, profiles: response.profiles.map((p) => ({ ...p, name: p.pt === 'main' ? 'Adults' : 'Kids' })) };
      });
  }

  getSelectedProfile(): ProfileItem | undefined {
    const profile = this.localStorage.getItem(LocalStorageKeys.SELECTED_PROFILE);
    return profile && profile !== 'undefined' ? JSON.parse(profile) : undefined;
  }

  async changeProfile(
    profile: ProfileItem,
    playbackService: PlaybackService,
    isFromLogin: boolean = false,
    isFromDeeplink = false
  ): Promise<void> {
    this.userState.startLoading();
    const prevProfile = this.getSelectedProfile();
    this.userState.updateSelectedProfile(profile);
    try {
      const result = await this.qpatService.getQPAT();
      this.localStorage.setItem(LocalStorageKeys.XAUTH_TOKEN, result.token);
      playbackService.resetPlayback();
      playbackService.initialiseSDK();
      if (isFromLogin) await playbackService.contentAuthorizer.registerDevice();
      this.userState.reloadPersonalization();
      this.datazoomService.updateMetadata();
      this.storefrontService.initialiseServices();
      this.searchService.initService();
      cleanRoutes(this.localStorage);
      if (!isFromDeeplink) {
        // set current tab as undefined to get redirection to home from storefront list resolver
        this.tabService.currentTabId = undefined;
        this.tabService.currentTabName = undefined;
        // send to router to get the new profile storefront id
        this.router.navigate(['/']).catch(() => {
          this.userState.stopLoading();
        });
      }
    } catch (error) {
      console.warn('[PROFILES] change profile', error);
      this.userState.updateSelectedProfile(prevProfile);
      this.userState.stopLoading();
    }
  }
}
